export default {
  screens: [
    {
      type: 'intro',
      title: 'A choice of sovereigns',
      content:
        'A surprising intermediary, the papal tiara of Pope Pius VII was the source of the meeting between Chaumet and Joséphine.',
      idYt: 'q7zuNJ10apM',
      videoCover: 'world/sovereign/video.jpg',
      desktop: {
        cover: 'world/sovereign/cover-1.jpg'
      },
      mobile: {
        cover: 'world/sovereign/mobile-cover-1.jpg',
        contentStyle: { width: '70%' },
        coverStyle: {
          width: '110%',
          top: '90%',
          left: '15%',
          position: 'absolute'
        }
      },
      isBottom: true
    },
    {
      type: 'columnVideo',
      content:
        'The most important of the diplomatic gifts given by Napoleon, the papal tiara of Pius VII was executed at the request of the Emperor in gratitude for the arrival of the sovereign Pontiff for his Coronation on 2 December 1804 at Notre-Dame de Paris.',
      idYt: 'O-1TKgKxDdg',
      videoCover: 'world/sovereign/video-2.jpg',
      cover: 'world/sovereign/cover-2.jpg',
      isBottom: true
    },
    {
      type: 'video',
      middleImg: 'world/sovereign/tiare.jpg',
      videoBlock: {
        cover: 'world/sovereign/video-3.jpg',
        idYt: '5ExHUFrxFms'
      },
      content:
        'For this exhibition, the Vatican entrusted Chaumet with the restoration of the papal tiara and the creation of a new cross to sit on top of the exceptional emerald at its summit.'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/locales/en/worlds/sovereign.js